export const CLOUDFRONT_URL: string = process.env.NEXT_PUBLIC_CLOUDFRONT_URL || "";
export const IMAGE_SHARE_CDN: string = process.env.NEXT_PUBLIC_IMAGE_SHARE_CDN || "";
export const IMAGE_CDN_BLOG: string = process.env.NEXT_PUBLIC_IMAGE_SHARE_CDN || "";
export const LOGIN_URL: string = process.env.NEXT_PUBLIC_LOGIN_URL || "";
export const KLARDA_APP_URL: string = process.env.NEXT_PUBLIC_KLARDA_APP_URL || "";
export const BASE_URL: string = process.env.NEXT_PUBLIC_BASE_URL || "";
export const IMAGE_CDN: string = process.env.NEXT_PUBLIC_IMAGE_CDN || "";
export const GOOGLE_CLIENT_ID: string = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "";
export const WALLET_CONNECT_PROJECT_ID: string = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID || "";
